import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { ExpertManagerEventNotificationRecord } from '@libs/shared/api';
import { SprintLogoAvatarComponent } from '@libs/shared/ui/avatar/sprint-logo-avatar.component';
import { UserAvatarComponent } from '@libs/shared/ui/avatar/user-avatar.component';

@Component({
  selector: 'app-expert-console-manager-join-inquiry-opened-notification',
  standalone: true,
  imports: [CommonModule, SprintLogoAvatarComponent, UserAvatarComponent],
  template: `
    <div class="flex cursor-pointer flex-row gap-4">
      <!-- Icon -->
      @if (!expertManagerEventNotification.notifier) {
        <app-sprint-logo-avatar />
      }
      <!-- Image -->
      @if (expertManagerEventNotification.notifier) {
        <app-user-avatar [user]="expertManagerEventNotification.notifier" />
      }
      <!-- Title, description & time -->
      <div class="flex w-full flex-col">
        <div class="line-clamp-1 font-semibold">
          {{ expertManagerEventNotification.notifier.nickname }}님이 센터
          합류요청을 하셨어요.
        </div>
        <div class="text-secondary line-clamp-2">
          매니저님의 합류 요청을 확인해주세요.
        </div>
        <div class="text-secondary mt-2 text-sm leading-none">
          {{
            expertManagerEventNotification.createdAt
              | date: 'yyyy-MM-dd (EEE), h:mm a'
          }}
        </div>
      </div>
    </div>
  `,
  styles: [],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ExpertConsoleManagerJoinInquiryOpenedNotificationComponent {
  @Input({ required: true })
  expertManagerEventNotification: ExpertManagerEventNotificationRecord;
}
